import React, { useEffect, useRef, useState } from "react";
import {
  Container,
  Form,
  InputGroup,
  Overlay,
  Table,
  Tooltip,
} from "react-bootstrap";
import listicon from "../assets/images/list.svg";
import cardicon from "../assets/images/cardicon.svg";
import actionLog from "../assets/images/actionLog.svg";
import filtericon from "../assets/images/filter.svg";
import addicon from "../assets/images/addicon.svg";
import historyAction from "../assets/images/historyaction.svg";
import notificationAction from "../assets/images/notificationaction.svg";
import notification from "../assets/images/notification.svg";
import viewAction from "../assets/images/viewaction.svg";
import editAction from "../assets/images/editaction.svg";
import deleteAction from "../assets/images/deleteaction.svg";
import activestatus from "../assets/images/activeStatus.svg";
import inactivestatus from "../assets/images/inactivestatus.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import SingleProjectCard from "./common-component/SingleProjectCard";
import SortAndFilterPopup from "./common-component/SortAndFilterPopup";
import AddProjectPopup from "./common-component/AddProjectPopup";
import homeImage from "../assets/images/home.svg";
import SchedularPopup from "./common-component/SchedularPopup";
import LogModal from "./common-component/LogModal";
import { apiResponse } from "../services/APIResponse";
import { API_URL } from "../services/APIRoute";
import { apiCall } from "../services/AxiosService";
import {
  commonservices,
  SKELETON_NAME,
  TIMEZONE_LIST,
} from "../services/CommonServices";
import SkeletonLoader from "./common-component/SkeletonLoader";
import Loader, { LoaderType } from "./common-component/Loader";
import { useDispatch, useSelector } from "react-redux";
import WorkFlowLogModal from "./common-component/WorkFlowLogModal";
import moment from "moment";
import noDataFound from "../assets/images/nodatafound.png";
import LineChartWithPointInline from "./common-component/LineChartWithPointInline";
import { Colors } from "chart.js";
import Nodata from "./common-component/Nodata";
import DeleteModal from "../Modals/DeleteModal";
import NotificationPopup from "./common-component/NotificationPopup";
import {
  GetWorkspaceListByID,
  setWorkFlowGetListData,
  WorkFlowGetList,
} from "../services/ReduxTookit/Slice/WorkFlowRedux";
import searchicon from "../assets/images/searchicon.svg";
import useDebounce from "../hooks/useDebounce";
import MachineWiseCostPopup from "./common-component/MachineWiseCostPopup";

function Projects() {
  const location = useLocation();
  const dispatch = useDispatch();
  const [modalShow, setModalShow] = useState(false);
  const [activeTab, setActiveTab] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const debouncingValue = useDebounce(searchValue, 500);

  useEffect(() => {
    if (location?.state?.param === "wc") {
      setActiveTab(1);
    } else if (location?.state?.param === "wl") {
      setActiveTab(0);
    }
  }, [location]);
  const [roleAccess, setRoleAccess] = useState({});
  const [flowName, setFlowName] = useState("");
  const [schedularData, setSchedularData] = useState(null);
  const [CronParseValues, setCronParseValues] = useState([]);
  const notificationPayloadRef = useRef();
  const [workspaceListOpt, setWorkspaceListOpt] = useState([]);

  const [workspaceFilter, setWorkspaceFilter] = useState([]);
  const FnForSetWorkspaceFilter = (data) => {
    setWorkspaceFilter(data);
  };
  const [value, setValue] = useState(0);
  const FnForSetValue = (data) => {
    setValue(data);
  };
  const [lastRun, setLastRun] = useState(null);
  const FnForSetLastRun = (data) => {
    setLastRun(data);
  };
  const [lastRunDate, setLastRunDate] = useState();
  const FnForSetLastRunDate = (data) => {
    setLastRunDate(data);
  };
  const [loading, setLoading] = useState(false);
  const FnForSetLoading = (data) => {
    setLoading(data);
  };
  const [nextRun, setNextRun] = useState(null);
  const FnForSetNextRun = (data) => {
    setNextRun(data);
  };
  const [nextRunDate, setNextRunDate] = useState();
  const FnForSetNextRunDate = (data) => {
    setNextRunDate(data);
  };
  const [billingStart, setBillingStart] = useState(0);
  const FnForSetBillingStart = (data) => {
    setBillingStart(data);
  };
  const [billingEnd, setBillingEnd] = useState(0);
  const FnForSetBillingEnd = (data) => {
    setBillingEnd(data);
  };
  const [status, setStatus] = useState("");
  const FnForSetStatus = (data) => {
    setStatus(data);
  };
  const [sort, setSort] = useState("machine");
  const FnForSetSort = (data) => {
    setSort(data);
  };
  const [sortOrder, setSortOrder] = useState("ASC");
  const FnForSetSortOrder = (data) => {
    setSortOrder(data);
  };

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };
  const [DeletePayload, setDeletePayload] = useState({
    workflowid: "",
    status: "",
  });
  const [showSortAndFilter, setShowSortAndFilter] = useState(false);
  let UserRoleRight = useSelector((state) => state.userinfo?.UserRoleRight);

  useEffect(() => {
    if (UserRoleRight) {
      setRoleAccess(commonservices?.GetRoleAccess("Workflow", UserRoleRight));
    }
  }, [UserRoleRight]);
  const [showNotification, setShowNotification] = useState(false);
  const handleshowNotification = () => {
    if (document.getElementById("body").classList.contains("popup-is-open")) {
      document.getElementById("body").classList.remove("popup-is-open");
    } else {
      document.getElementById("body").classList.add("popup-is-open");
    }
    setShowNotification(!showNotification);
  };
  const handleshowSortAndFilter = (e) => {
    if (document.getElementById("body").classList.contains("popup-is-open")) {
      document.getElementById("body").classList.remove("popup-is-open");
      // handleOverlay(e);
    } else {
      document.getElementById("body").classList.add("popup-is-open");
    }
    setShowSortAndFilter(!showSortAndFilter);
  };
  const [showAddProjectPopup, setShowAddProjectPopup] = useState(false);
  const handleSchedularSubmit = (data) => {
    setSchedularData(data);
    // setCroneExpressionValue(data?.["WorkFlowSchedule.cronexpression"]);
  };
  const SetScheduler = (item) => {
    let schedularDataObj = {
      "WorkFlowSchedule.timezone": item?.timezone,
      "WorkFlowSchedule.startondatetime": item?.startondatetime
        ? moment(item?.startondatetime).format("YYYY-MM-DD")
        : "",
      "WorkFlowSchedule.endondatetime": item?.endondatetime
        ? moment(item?.endondatetime).format("YYYY-MM-DD")
        : "",
      "WorkFlowSchedule.scheduledays": item?.scheduledays,
      "WorkFlowSchedule.schedulemonth": item?.schedulemonth,
      "WorkFlowSchedule.hour": item?.schedulehour,
      "WorkFlowSchedule.minute": item?.scheduleminute,
      "WorkFlowSchedule.weekdays": item?.scheduleweekday,
      "WorkFlowSchedule.cronexpression": item?.cronexpression,
      "filter.minute": item?.scheduleminute === "all" ? true : false,
      "filter.hour": item?.schedulehour === "all" ? true : false,
      "filter.date": item?.scheduledays === "all" ? true : false,
    };
    setFlowName(item?.workflowname);
    setSchedularData(schedularDataObj);
  };
  const handleshowAddProjectPopup = (e) => {
    if (document.getElementById("body").classList.contains("popup-is-open")) {
      document.getElementById("body").classList.remove("popup-is-open");
      // handleOverlay(e);
    } else {
      document.getElementById("body").classList.add("popup-is-open");
    }
    setShowAddProjectPopup(!showAddProjectPopup);
  };

  let navigate = useNavigate();
  const target = useRef(null);

  const target1 = useRef(null);

  const target2 = useRef(null);

  const [show, setShow] = useState(false);

  const handleOverlay = (e) => {
    let element = document.getElementById(e?.currentTarget?.id);
    if (element) {
      if (element.classList.contains("overlay-isopen")) {
        element.classList.remove("overlay-isopen");
      } else {
        element.classList.add("overlay-isopen");
      }
    }
  };

  const [showSchedulerPopup, setShowSchedulerPopup] = useState(false);

  const handleshowSchedulerPopup = (e) => {
    if (document.getElementById("body").classList.contains("popup-is-open")) {
      document.getElementById("body").classList.remove("popup-is-open");
      handleOverlay(e);
    } else {
      document.getElementById("body").classList.add("popup-is-open");
    }
    setShowSchedulerPopup(!showSchedulerPopup);
  };

  const targetScheduler = useRef(null);
  const [modalShow1, setModalShow1] = useState(false);
  const [logId, setLogId] = useState(0);

  const [workflowList, setWorkflowList] = useState(null);

  const FilterData = (data) => {
    setWorkflowList(data);
  };

  function getWorkFlowList() {
    setLoading(true);
    let request = {
      searchText: debouncingValue,
    };
    dispatch(WorkFlowGetList(request));

    // let resData = await apiCall(
    //   {
    //     method: "POST",
    //     url: API_URL.BASEURL + API_URL.WORKFLOWGETLIST,
    //   },
    //   false
    // );
    // let response = apiResponse(false, resData, setLoading);
    // if (response?.isValidate) {
    //   setWorkflowList(response?.data?.data);
    // }
    // if (!response?.isValidate) {
    //   setWorkflowList(null);
    // }
  }

  const fetchWorkspaceList = () => {
    dispatch(GetWorkspaceListByID(0))?.then((response) => {
      if (response?.payload?.isValidate) {
        if (response?.payload?.data?.data?.length > 0) {
          let _WorkspaceOpt = [];
          response?.payload?.data?.data.forEach((element) => {
            _WorkspaceOpt.push({
              value: element?.workspacename,
              label: element?.workspacename,
            });
          });
          setWorkspaceListOpt(_WorkspaceOpt);
        }
      }
      if (!response?.payload?.isValidate) {
      }
    });
  };

  useEffect(() => {
    fetchWorkspaceList();
    getWorkFlowList();
    return () => {
      dispatch(setWorkFlowGetListData());
    };
  }, [debouncingValue]);

  const getWorkFlowGetListData = useSelector(
    (item) => item?.workflowredux?.WorkFlowGetListData?.data,
  );

  useEffect(() => {
    if (getWorkFlowGetListData && getWorkFlowGetListData?.isValidate) {
      setWorkflowList(getWorkFlowGetListData?.data?.data);
      setLoading(false);
    }
    if (getWorkFlowGetListData && !getWorkFlowGetListData?.isValidate) {
      setWorkflowList(null);
      setLoading(false);
    }
  }, [getWorkFlowGetListData]);

  const getTimeZoneObj = (timezone) => {
    let filterdData = TIMEZONE_LIST?.filter((x) => x?.value === timezone);

    return filterdData;
  };

  //#region Close ToolTip / Overlays Outside Click ----------------------

  const overlayNoti_Ref = useRef(null);

  const handleOutsideClick = (event) => {
    if (
      overlayNoti_Ref.current &&
      !overlayNoti_Ref.current.contains(event.target) &&
      !target2.current.contains(event.target)
    ) {
      handleshowNotification(event); // Close the overlay
    }
  };

  useEffect(() => {
    if (showNotification) {
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [showNotification]);

  const [machinewiseflowName, setmachinewiseflowName] = useState("");
  const [machinewiseworkflowid, setmachinewiseworkflowid] = useState("");
  const [showtype, setShowType] = useState("");
  const targetMachinewiseRef = useRef({});

  const getTargetRef = (workflowid, type) => {
    const key = `${workflowid}_${type}`;
    if (!targetMachinewiseRef.current[key]) {
      targetMachinewiseRef.current[key] = React.createRef();
    }
    return targetMachinewiseRef.current[key];
  };

  const handleOverlayForMachineWiseCost = (e) => {
    let element = document.getElementById(e?.currentTarget?.id);
    if (element) {
      if (element.classList.contains("overlay-isopen")) {
        element.classList.remove("overlay-isopen");
      } else {
        element.classList.add("overlay-isopen");
      }
    }
  };

  const [showMachineWiseCostPopup, setShowMachineWiseCostPopup] =
    useState(false);

  const handleshowMachineWiseCostPopup = (e) => {
    if (document.getElementById("body").classList.contains("popup-is-open")) {
      document.getElementById("body").classList.remove("popup-is-open");
      handleOverlayForMachineWiseCost(e);
    } else {
      document.getElementById("body").classList.add("popup-is-open");
    }
    setShowMachineWiseCostPopup(!showMachineWiseCostPopup);
  };

  const handleshowtypeclick = (projectname, workflowid, showtype, e) => {
    setmachinewiseflowName(projectname);
    setmachinewiseworkflowid(workflowid);
    setShowType(showtype);
    handleshowMachineWiseCostPopup(e);
  };

  //#endregion ----------------------

  return (
    <div className="projects-page-main all-page-top">
      <Container>
        <div className="top-bot-section workflow-tab">
          <h6>
            <div className="d-flex gap-2 align-items-center">
              <div style={{ display: "flex", alignItems: "center" }}>
                <img
                  src={homeImage}
                  alt="home"
                  title="home"
                  style={{ cursor: "pointer", marginBottom: "3px" }}
                  onClick={() => navigate("/")}
                />
                <span style={{ fontWeight: "400", color: "#666666" }}>
                  {" | "}
                </span>
                <span className="mt-1">
                  Workflow{" "}
                  {workflowList?.length > 0 && `(${workflowList?.length})`}
                  {/* Workflow */}
                </span>
              </div>
              <div className="header-search-input searchplaceholder">
                <InputGroup>
                  <InputGroup.Text id="basic-addon1">
                    <img
                      src={searchicon}
                      alt="searchicon"
                      className="cursor-pointer"
                    />
                  </InputGroup.Text>
                  <Form.Control
                    placeholder={`Search Workflow`}
                    aria-label="Search"
                    aria-describedby="basic-addon1"
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                  />
                </InputGroup>
              </div>
            </div>
          </h6>
          <div className="custom-tabing singledesh-tab">
            <div
              className={activeTab === 1 ? "single-tab active" : "single-tab"}
              onClick={() => handleTabClick(1)}
            >
              <img src={cardicon} alt="cardicon" />
              <span>Card</span>
            </div>
            <div
              className={activeTab === 0 ? "single-tab active" : "single-tab"}
              onClick={() => handleTabClick(0)}
            >
              <img src={listicon} alt="listicon" />
              <span>List</span>
            </div>
          </div>
          <div className="top-bot-right-section">
            <div className="d-flex gap-2">
              <div className="listcolor">
                <div className="listcolor-block">
                  <div
                    className="listcolor-icon"
                    style={{ backgroundColor: "#75BDE7" }}
                  ></div>
                  <div className="listcolor-detail">
                    <p>CPU Usage</p>
                  </div>
                </div>
                <div className="listcolor-block">
                  <div
                    className="listcolor-icon "
                    style={{ backgroundColor: "#BC6CD4" }}
                  ></div>
                  <div className="listcolor-detail">
                    <p>Memory Usage</p>
                  </div>
                </div>
                <div className="listcolor-block">
                  <div
                    className="listcolor-icon "
                    style={{ backgroundColor: "#D89965" }}
                  ></div>
                  <div className="listcolor-detail">
                    <p>Network Usage</p>
                  </div>
                </div>
              </div>
              <div
                className={
                  showSortAndFilter
                    ? "filtering-main overlay-isopen"
                    : "filtering-main"
                }
                id="sort-filter"
                onClick={(e) => {
                  e.preventDefault();
                  // handleOverlay(e);
                  setShowSortAndFilter(!showSortAndFilter);
                  handleshowSortAndFilter();
                }}
                ref={target1}
              >
                <img src={filtericon} alt="filtericon" />
                <span>Sort & Filter</span>
              </div>
              {showSortAndFilter ? (
                <>
                  <Overlay
                    target={target1.current}
                    show={showSortAndFilter}
                    placement="bottom"
                  >
                    {(props) => (
                      <Tooltip id="overlay-example" {...props}>
                        <SortAndFilterPopup
                          searchValue={searchValue}
                          setSearchValue={setSearchValue}
                          handleshowPopup={handleshowSortAndFilter}
                          getData={FilterData}
                          workspaceListOpt={workspaceListOpt}
                          FnForSetWorkspaceFilter={FnForSetWorkspaceFilter}
                          FnForSetValue={FnForSetValue}
                          FnForSetLastRun={FnForSetLastRun}
                          FnForSetLastRunDate={FnForSetLastRunDate}
                          FnForSetLoading={FnForSetLoading}
                          FnForSetNextRun={FnForSetNextRun}
                          FnForSetNextRunDate={FnForSetNextRunDate}
                          FnForSetBillingStart={FnForSetBillingStart}
                          FnForSetBillingEnd={FnForSetBillingEnd}
                          FnForSetStatus={FnForSetStatus}
                          FnForSetSort={FnForSetSort}
                          FnForSetSortOrder={FnForSetSortOrder}
                          workspaceFilter={workspaceFilter}
                          value={value}
                          lastRun={lastRun}
                          nextRun={nextRun}
                          billingStart={billingStart}
                          billingEnd={billingEnd}
                          status={status}
                          sort={sort}
                          sortOrder={sortOrder}
                        />
                      </Tooltip>
                    )}
                  </Overlay>
                </>
              ) : (
                ""
              )}
              {roleAccess?.iscreate && (
                <>
                  <div
                    className={
                      showAddProjectPopup
                        ? "filtering-main overlay-isopen"
                        : "filtering-main"
                    }
                    id="add-project"
                    onClick={(e) => {
                      e.preventDefault();
                      // handleOverlay(e);
                      // setShow(!show);
                      setShowAddProjectPopup(!showAddProjectPopup);
                      handleshowAddProjectPopup();
                    }}
                    ref={target}
                  >
                    <img src={addicon} alt="filtericon" />
                    <span>Add</span>
                  </div>
                  {/* </Link> */}
                  {showAddProjectPopup ? (
                    <>
                      <Overlay
                        target={target.current}
                        show={showAddProjectPopup}
                        placement="bottom"
                      >
                        {(props) => (
                          <Tooltip id="overlay-example" {...props}>
                            <AddProjectPopup
                              handleshowPopup={handleshowAddProjectPopup}
                              activeTab={activeTab}
                            />
                          </Tooltip>
                        )}
                      </Overlay>
                    </>
                  ) : (
                    ""
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </Container>
      <div className="main-page-content">
        <Container>
          {activeTab === 0 ? (
            <div className="common-table-main">
              <div className="table-wrapper-main">
                <Table responsive>
                  <thead>
                    <tr>
                      <th className="width250 sticky-workflow">
                        Workflow Name
                      </th>
                      <th className="text-center">Runs</th>
                      <th className="text-center">Results</th>
                      <th className="text-center">Machine</th>
                      {/* <th className="width100">Active</th> */}
                      <th className="text-center text-nowrap">Last Run</th>
                      <th className="text-center text-nowrap">Next schedule</th>
                      <th className="">Status</th>
                      <th className="width140">Workspace</th>
                      <th className="text-end width140">Billing</th>
                      <th className="width160 text-center">CPU Usage</th>
                      <th className="width160 text-center">Memory Usage</th>
                      <th className="width160 text-center">Network Usage </th>
                      <th className="text-end sticky-actions">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <Loader
                        type={LoaderType.TableRow}
                        count={6}
                        nooftd={13}
                      />
                    ) : (
                      <>
                        {workflowList?.length > 0 ? (
                          workflowList?.map((item) => {
                            let timeZone = getTimeZoneObj(
                              item?.timezone ? item?.timezone : "",
                            );

                            const workspaces = item?.workspacename
                              ? item.workspacename
                                  .split(",")
                                  .map((w) => w.trim())
                              : [];

                            return (
                              <tr key={item?.workflowid}>
                                <td
                                  className="theme-color-text fw600 sticky-workflow"
                                  title={item?.workflowname}
                                >
                                  <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      let data = commonservices.bodyEncryption(
                                        `${item?.workflowid}?v=1&r=wl`,
                                      );
                                      navigate(
                                        `/flow-new-view/${data}`,
                                        // `/flow-new/${data}`,
                                        {
                                          state: {
                                            isViewMode: true,
                                            flowRoleRights: item,
                                          },
                                        },
                                      );
                                    }}
                                  >
                                    {commonservices.truncateText(
                                      item?.workflowname,
                                      30,
                                    )}
                                  </span>
                                </td>
                                <td className="text-center">
                                  {(item?.totalsuccessed
                                    ? item?.totalsuccessed
                                    : 0) +
                                    (item?.totalfailed ? item?.totalfailed : 0)}
                                </td>
                                <td className="text-center">
                                  <span className="green-color-text-sucess">
                                    {item?.totalsuccessed
                                      ? item?.totalsuccessed
                                      : 0}
                                  </span>
                                  <span className="red-color-text">
                                    /{item?.totalfailed ? item?.totalfailed : 0}
                                  </span>
                                </td>
                                <td className="text-center">
                                  {/* <Link to="/scheduler/schedular-detail"> */}
                                  {item?.totalmachine ? item?.totalmachine : 0}
                                  {/* </Link> */}
                                </td>

                                <td className="text-center text-nowrap">
                                  {item?.lastrunon
                                    ? commonservices.convertTimeToLocal(
                                        item?.lastrunon,
                                      )
                                    : ""}{" "}
                                  <span style={{ fontSize: "9px" }}>
                                    {" "}
                                    {/* {item?.lastrunon
                                      ? timeZone?.[0]?.shortValue
                                      : ""}{" "} */}
                                    {item?.lastrunon
                                      ? commonservices.convertDateToLocal(
                                          item?.lastrunon,
                                        )
                                      : ""}{" "}
                                  </span>
                                </td>

                                <td className="text-center ">
                                  {item?.argoworkflowstatus === "Active" &&
                                  item?.nextrunon
                                    ? commonservices.convertTimeToLocal(
                                        item?.nextrunon,
                                      )
                                    : ""}{" "}
                                  <span style={{ fontSize: "9px" }}>
                                    {/* {item?.argoworkflowstatus === "Active" &&
                                    item?.nextrunon
                                      ? timeZone?.[0]?.shortValue
                                      : ""}{" "} */}
                                    {item?.argoworkflowstatus === "Active" &&
                                    item?.nextrunon
                                      ? commonservices.convertDateToLocal(
                                          item?.nextrunon,
                                        )
                                      : ""}{" "}
                                  </span>
                                </td>
                                <td className="text-center">
                                  <div className="d-flex">
                                    <div className="mt-1 me-1">
                                      {commonservices.getStatus(
                                        item?.argoworkflowstatus,
                                      )}
                                    </div>
                                    <span className="mt-1">
                                      {commonservices.getWithoutDotStatus(
                                        item?.laststatus,
                                      )}
                                    </span>
                                  </div>
                                </td>
                                <td>
                                  {workspaces.length > 0 && (
                                    <div className="workspace-wrapper p-1 work-space">
                                      <div className="d-flex gap-1 flex-nowrap align-items-center">
                                        <span className="custom-chip chip-maxw">
                                          {workspaces[0]}
                                        </span>

                                        {workspaces.length > 1 && (
                                          <div className="tooltip-wrapper">
                                            <span className="custom-chip">
                                              +{workspaces.length - 1}
                                            </span>

                                            <div className="tooltip-content">
                                              {workspaces
                                                .slice(1)
                                                .map((ws, idx) => (
                                                  <div key={idx}>{ws}</div>
                                                ))}
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                </td>

                                <td className="text-end">
                                  {/* ${item?.totalcost ? item?.totalcost : 0} */}
                                  $
                                  {item?.totalcost
                                    ? commonservices.fnAmountDigitCount(
                                        item?.totalcost,
                                        5,
                                      )
                                    : 0}
                                </td>

                                <td className="dashboard-listing-chart ">
                                  <div
                                    className="line-chart-in-table"
                                    style={{ marginLeft: "27px" }}
                                  >
                                    <LineChartWithPointInline
                                      data={
                                        item?.chartdata &&
                                        JSON.parse(item?.chartdata)
                                      }
                                      params={"CPU Usage"}
                                    />
                                  </div>
                                </td>
                                <td className="dashboard-listing-chart">
                                  <div
                                    className="line-chart-in-table"
                                    style={{ marginLeft: "27px" }}
                                  >
                                    <LineChartWithPointInline
                                      data={
                                        item?.chartdata &&
                                        JSON.parse(item?.chartdata)
                                      }
                                      params={"Memory Usage"}
                                    />
                                  </div>
                                </td>
                                <td className="dashboard-listing-chart">
                                  <div
                                    className="line-chart-in-table"
                                    style={{ marginLeft: "27px" }}
                                  >
                                    <LineChartWithPointInline
                                      data={
                                        item?.chartdata &&
                                        JSON.parse(item?.chartdata)
                                      }
                                      params={"Network Usage"}
                                    />
                                  </div>
                                </td>

                                <td className="sticky-actions">
                                  <div className="all-actions">
                                    <img
                                      src={historyAction}
                                      alt="historyaction"
                                      title="Scheduler"
                                      id={`next${item?.workflowid}`}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        targetScheduler.current =
                                          document.querySelector(
                                            `#next${item?.workflowid}`,
                                          );
                                        handleOverlay(e);
                                        setShow(!show);
                                        handleshowSchedulerPopup();
                                        SetScheduler(item);
                                      }}
                                      ref={targetScheduler}
                                    />
                                    {/* <img
                                      id={`nextt${item?.workflowid}`}
                                      src={notificationAction}
                                      alt="notificationAction"
                                      title="Notification"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        target2.current =
                                          document.querySelector(
                                            `#nextt${item?.workflowid}`
                                          );
                                        notificationPayloadRef.current = {
                                          associationId: item?.workflowid,
                                          associationType: "workflow",
                                        };
                                        setShowNotification(!showNotification);
                                        handleshowNotification();
                                      }}
                                    /> */}

                                    <span
                                      id={`nextt${item?.workflowid}`}
                                      title="Notification"
                                      className="notification-blink-btn"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        target2.current =
                                          document.querySelector(
                                            `#nextt${item?.workflowid}`,
                                          );
                                        notificationPayloadRef.current = {
                                          associationId: item?.workflowid,
                                          associationType: "workflow",
                                        };
                                        setShowNotification(!showNotification);
                                        handleshowNotification();
                                      }}
                                    >
                                      <img
                                        src={notification}
                                        alt="Notification"
                                        className="sm-icons"
                                        ref={target2}
                                        // className="sm-icons"
                                      />
                                      {/* <span className="notification-count"></span> */}
                                    </span>
                                    <img
                                      src={actionLog}
                                      alt="actionLog"
                                      title="Log"
                                      onClick={() => {
                                        setModalShow1(true);
                                        setLogId(item?.workflowid);
                                      }}
                                    />
                                    {item?.canview && (
                                      <>
                                        {/* <Link to="/projects/project-view">
                                    <img
                                      src={viewAction}
                                      alt="viewAction"
                                      title="View"
                                    />
                                  </Link> */}
                                        <span
                                          onClick={() => {
                                            let data =
                                              commonservices.bodyEncryption(
                                                `${item?.workflowid}?v=1&r=wl`,
                                              );
                                            navigate(
                                              // `/flow-new/${data}`,
                                              `/flow-new-view/${data}`,
                                              {
                                                state: {
                                                  isViewMode: true,
                                                  flowRoleRights: item,
                                                },
                                              },
                                            );
                                          }}
                                        >
                                          <img
                                            src={viewAction}
                                            alt="viewAction"
                                            title="View"
                                          />
                                        </span>
                                      </>
                                    )}
                                    {/* {item?.canedit && (
                                  <img
                                    src={editAction}
                                    alt="editAction"
                                    title="Edit"
                                  />
                                )} */}

                                    {item?.canedit && (
                                      <>
                                        {/* <Link to={`/flow/${item?.workflowid}`}>
                                    <img
                                      src={editAction}
                                      alt="editAction"
                                      title="Edit"
                                    />
                                  </Link> */}
                                        <span
                                          onClick={() => {
                                            let data =
                                              commonservices.bodyEncryption(
                                                `${item?.workflowid}?v=0&r=wl`,
                                              );
                                            navigate(
                                              `/flow-new/${data}
                                              `,
                                              {
                                                state: {
                                                  isViewMode: false,
                                                  flowRoleRights: item,
                                                },
                                              },
                                            );
                                          }}
                                        >
                                          <img
                                            src={editAction}
                                            alt="editAction"
                                            title="Edit"
                                          />
                                        </span>
                                      </>
                                    )}

                                    {item?.candelete && (
                                      <img
                                        src={deleteAction}
                                        alt="deleteAction"
                                        title="Delete"
                                        onClick={() => {
                                          setModalShow(true);
                                          setDeletePayload({
                                            workflowid: item?.workflowid,
                                            status: "Delete",
                                          });
                                        }}
                                      />
                                    )}
                                  </div>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <></>
                          // <tr>
                          //   <td colSpan={100}>
                          //     {" "}
                          //     <Nodata />
                          //   </td>
                          // </tr>
                        )}
                      </>
                    )}
                  </tbody>
                </Table>
                {((workflowList && workflowList?.length === 0) ||
                  !workflowList) &&
                  !loading && (
                    <>
                      <Table>
                        <tbody>
                          <tr>
                            <td>
                              <Nodata />
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </>
                  )}
              </div>
            </div>
          ) : (
            <>
              <div className="all-dashboard-projects-main mb-3">
                {loading ? (
                  <>
                    <Loader type={LoaderType.ProjectCard} count={8} />
                  </>
                ) : workflowList ? (
                  workflowList?.map((item) => {
                    return (
                      <SingleProjectCard
                        key={item?.workflowid}
                        item={{ ...item }}
                        projectName={item?.workflowname}
                        // cubeNo="5"
                        cubeNo={item?.totalmachine ? item?.totalmachine : 0}
                        dollarNo={item?.totalcost ? item?.totalcost : 0}
                        lastRunTime={
                          item?.lastrunon
                            ? commonservices.convertTimeToLocal(item?.lastrunon)
                            : ""
                        }
                        lastRunDate={
                          item?.lastrunon
                            ? commonservices.convertDateToLocal(item?.lastrunon)
                            : ""
                        }
                        nextRunTime={
                          item?.nextrunon
                            ? commonservices.convertTimeToLocal(item?.nextrunon)
                            : ""
                        }
                        nextRunDate={
                          item?.nextrunon
                            ? commonservices.convertDateToLocal(item?.nextrunon)
                            : ""
                        }
                        activestatus={
                          item?.argoworkflowstatus === "Active"
                            ? activestatus
                            : inactivestatus
                        }
                        activestatusLabel={item?.argoworkflowstatus}
                        status={item?.laststatus}
                        code={
                          (item?.totalsuccessed ? item?.totalsuccessed : 0) +
                          (item?.totalfailed ? item?.totalfailed : 0)
                        }
                        succeed={
                          item?.totalsuccessed ? item?.totalsuccessed : 0
                        }
                        failed={item?.totalfailed ? item?.totalfailed : 0}
                        workFlowId={item?.workflowid}
                        canView={item?.canview}
                        canedit={item?.canedit}
                        candelete={item?.candelete}
                        callFunction={getWorkFlowList}
                        lastRunCost={item?.lastruncost ? item?.lastruncost : 0}
                        mtdcost={item?.mtd ? item?.mtd : 0}
                        handleshowtypeclick={handleshowtypeclick}
                        getTargetRef={getTargetRef}
                      />
                    );
                  })
                ) : (
                  <Nodata />
                )}
              </div>
            </>
          )}
        </Container>
      </div>
      {modalShow && (
        <DeleteModal
          payload={DeletePayload}
          url={API_URL.WORKFLOW.UPDATE_WORKFLOW_STATUS}
          show={modalShow}
          bindlist={getWorkFlowList}
          onHide={(e) => setModalShow(false)}
        />
      )}
      {showSchedulerPopup && (
        <Overlay
          target={targetScheduler.current}
          show={showSchedulerPopup}
          placement="bottom"
        >
          {(props) => (
            <Tooltip id="overlay-example" {...props}>
              <SchedularPopup
                isViewMode={
                  location?.pathname?.includes("/dashboard") ||
                  location?.pathname?.includes("/workflows")
                }
                handleSubmit={handleSchedularSubmit}
                handleshowPopup={handleshowSchedulerPopup}
                CronParseValues={CronParseValues}
                flowName={flowName}
                schedularData={schedularData}
              />
            </Tooltip>
          )}
        </Overlay>
      )}
      {/* <LogModal show={modalShow1} onHide={() => setModalShow1(false)} /> */}
      {showNotification ? (
        <>
          <Overlay
            ref={overlayNoti_Ref}
            target={target2.current}
            show={showNotification}
            placement="bottom"
          >
            {(props) => (
              <Tooltip id="overlay-example" {...props}>
                <NotificationPopup
                  closePopup={handleshowNotification}
                  associationId={notificationPayloadRef.current?.associationId}
                  associationType={
                    notificationPayloadRef.current?.associationType
                  }
                />
              </Tooltip>
            )}
          </Overlay>
        </>
      ) : (
        ""
      )}
      {modalShow1 && (
        <WorkFlowLogModal
          show={modalShow1}
          id={logId}
          onHide={() => setModalShow1(false)}
        />
      )}

      {showMachineWiseCostPopup && (
        <Overlay
          target={
            targetMachinewiseRef.current[`${machinewiseworkflowid}_${showtype}`]
              ?.current
          }
          show={showMachineWiseCostPopup}
          placement="bottom"
        >
          {(props) => (
            <Tooltip id="overlay-example" {...props}>
              <MachineWiseCostPopup
                projectname={machinewiseflowName}
                workflowid={machinewiseworkflowid}
                showtype={showtype}
                handleshowPopup={handleshowMachineWiseCostPopup}
              />
            </Tooltip>
          )}
        </Overlay>
      )}
    </div>
  );
}

export default Projects;
